import React from 'react';
import Recommend from '../_common/Recommend';

export default function PartnerProjectEvaluationSummarySection(props) {
  const { evaluation } = props;

  return (
    <>
      <Recommend evaluation={evaluation} />
    </>
  );
};
